import { render, staticRenderFns } from "./NuageIcon.vue?vue&type=template&id=72ed75f2"
import script from "./NuageIcon.vue?vue&type=script&lang=js"
export * from "./NuageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports